// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.course-container {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 2rem;
  height: calc(100vh - 4rem);
  padding: 2rem;
  background-color: #f0f7f0;
}

.course-index {
  background-color: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: fit-content;
  overflow-y: auto;
  max-height: calc(100vh - 8rem);
}

.course-index h2 {
  margin-bottom: 1.5rem;
  color: #2c5530;
  font-size: 1.5rem;
  position: sticky;
  top: 0;
  background-color: white;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e8f3e8;
  z-index: 1;
}

.modules-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.course-overview {
  margin-bottom: 1rem;
  border-bottom: 1px solid #edf2f7;
  padding-bottom: 1rem;
}

.overview-header {
  padding: 0.75rem 1rem;
  background-color: #4299e1;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;
}

.overview-header:hover {
  background-color: #3182ce;
}

.overview-header.active {
  background-color: #2b6cb0;
}

.module {
  margin-bottom: 0.5rem;
}

.module-header {
  padding: 0.75rem 1rem;
  background-color: #f0f7f0;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #2c5530;
  transition: all 0.2s ease;
}

.module-header:hover {
  background-color: #e8f3e8;
}

.lessons-list {
  list-style: none;
  padding: 0.5rem 0 0.5rem 1rem;
  margin: 0;
}

.lesson {
  margin-bottom: 0.25rem;
}

.lesson-header {
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #4a6b4d;
  transition: all 0.2s ease;
}

.lesson-header:hover {
  color: #2c5530;
}

.topics-list {
  list-style: none;
  padding: 0.5rem 0 0.5rem 1rem;
  margin: 0;
}

.topic {
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  color: #4a6b4d;
  transition: all 0.2s ease;
  border-radius: 4px;
  margin-bottom: 0.25rem;
}

.topic:hover {
  background-color: #e8f3e8;
  color: #2c5530;
}

.topic.active {
  background-color: #4caf50;
  color: white;
}

.expand-icon {
  margin-right: 0.5rem;
  font-size: 0.8rem;
  color: #4a6b4d;
  transition: transform 0.2s ease;
}

.course-content {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  max-height: calc(100vh - 8rem);
}

.course-content h2 {
  color: #2c5530;
  margin-bottom: 1.5rem;
  font-size: 1.8rem;
  border-bottom: 2px solid #e8f3e8;
  padding-bottom: 1rem;
}

.content-text {
  color: #4a6b4d;
  line-height: 1.6;
}

.content-text p {
  margin-bottom: 1rem;
}

.content-text h1 {
  color: #2c5530;
  font-size: 2rem;
  margin-bottom: 1.5rem;
}

.content-text h2 {
  color: #2c5530;
  font-size: 1.5rem;
  margin: 2rem 0 1rem;
  border-bottom: none;
  padding-bottom: 0;
}

.content-text ul {
  margin: 1rem 0;
  padding-left: 1.5rem;
}

.content-text li {
  margin-bottom: 0.5rem;
}

.placeholder {
  text-align: center;
  color: #4a6b4d;
  padding: 2rem;
}

.placeholder h2 {
  margin-bottom: 1rem;
  border-bottom: none;
}

.content-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: #4a6b4d;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e8f3e8;
  border-top: 4px solid #4caf50;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.content-error {
  padding: 2rem;
  color: #d32f2f;
  text-align: center;
}

.content-error h2 {
  color: #d32f2f;
  margin-bottom: 1rem;
}

@media (max-width: 768px) {
  .course-container {
    grid-template-columns: 1fr;
    padding: 1rem;
    height: auto;
  }

  .course-index {
    margin-bottom: 1rem;
    max-height: none;
  }

  .course-content {
    max-height: none;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/CourseIndex.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,0BAA0B;EAC1B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,uBAAuB;EACvB,oBAAoB;EACpB,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,aAAa;IACb,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".course-container {\n  display: grid;\n  grid-template-columns: 300px 1fr;\n  gap: 2rem;\n  height: calc(100vh - 4rem);\n  padding: 2rem;\n  background-color: #f0f7f0;\n}\n\n.course-index {\n  background-color: white;\n  padding: 1.5rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  height: fit-content;\n  overflow-y: auto;\n  max-height: calc(100vh - 8rem);\n}\n\n.course-index h2 {\n  margin-bottom: 1.5rem;\n  color: #2c5530;\n  font-size: 1.5rem;\n  position: sticky;\n  top: 0;\n  background-color: white;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #e8f3e8;\n  z-index: 1;\n}\n\n.modules-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.course-overview {\n  margin-bottom: 1rem;\n  border-bottom: 1px solid #edf2f7;\n  padding-bottom: 1rem;\n}\n\n.overview-header {\n  padding: 0.75rem 1rem;\n  background-color: #4299e1;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.overview-header:hover {\n  background-color: #3182ce;\n}\n\n.overview-header.active {\n  background-color: #2b6cb0;\n}\n\n.module {\n  margin-bottom: 0.5rem;\n}\n\n.module-header {\n  padding: 0.75rem 1rem;\n  background-color: #f0f7f0;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  color: #2c5530;\n  transition: all 0.2s ease;\n}\n\n.module-header:hover {\n  background-color: #e8f3e8;\n}\n\n.lessons-list {\n  list-style: none;\n  padding: 0.5rem 0 0.5rem 1rem;\n  margin: 0;\n}\n\n.lesson {\n  margin-bottom: 0.25rem;\n}\n\n.lesson-header {\n  padding: 0.5rem 0.75rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  color: #4a6b4d;\n  transition: all 0.2s ease;\n}\n\n.lesson-header:hover {\n  color: #2c5530;\n}\n\n.topics-list {\n  list-style: none;\n  padding: 0.5rem 0 0.5rem 1rem;\n  margin: 0;\n}\n\n.topic {\n  padding: 0.5rem 0.75rem;\n  cursor: pointer;\n  color: #4a6b4d;\n  transition: all 0.2s ease;\n  border-radius: 4px;\n  margin-bottom: 0.25rem;\n}\n\n.topic:hover {\n  background-color: #e8f3e8;\n  color: #2c5530;\n}\n\n.topic.active {\n  background-color: #4caf50;\n  color: white;\n}\n\n.expand-icon {\n  margin-right: 0.5rem;\n  font-size: 0.8rem;\n  color: #4a6b4d;\n  transition: transform 0.2s ease;\n}\n\n.course-content {\n  background-color: white;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow-y: auto;\n  max-height: calc(100vh - 8rem);\n}\n\n.course-content h2 {\n  color: #2c5530;\n  margin-bottom: 1.5rem;\n  font-size: 1.8rem;\n  border-bottom: 2px solid #e8f3e8;\n  padding-bottom: 1rem;\n}\n\n.content-text {\n  color: #4a6b4d;\n  line-height: 1.6;\n}\n\n.content-text p {\n  margin-bottom: 1rem;\n}\n\n.content-text h1 {\n  color: #2c5530;\n  font-size: 2rem;\n  margin-bottom: 1.5rem;\n}\n\n.content-text h2 {\n  color: #2c5530;\n  font-size: 1.5rem;\n  margin: 2rem 0 1rem;\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.content-text ul {\n  margin: 1rem 0;\n  padding-left: 1.5rem;\n}\n\n.content-text li {\n  margin-bottom: 0.5rem;\n}\n\n.placeholder {\n  text-align: center;\n  color: #4a6b4d;\n  padding: 2rem;\n}\n\n.placeholder h2 {\n  margin-bottom: 1rem;\n  border-bottom: none;\n}\n\n.content-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  color: #4a6b4d;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #e8f3e8;\n  border-top: 4px solid #4caf50;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.content-error {\n  padding: 2rem;\n  color: #d32f2f;\n  text-align: center;\n}\n\n.content-error h2 {\n  color: #d32f2f;\n  margin-bottom: 1rem;\n}\n\n@media (max-width: 768px) {\n  .course-container {\n    grid-template-columns: 1fr;\n    padding: 1rem;\n    height: auto;\n  }\n\n  .course-index {\n    margin-bottom: 1rem;\n    max-height: none;\n  }\n\n  .course-content {\n    max-height: none;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
